import { defineVariants } from "@/runtime/style-engine/define-variants";

export const imageMediaClasses = defineVariants({
  base: `block w-full h-full object-cover`,
  variants: {
    rounded: {
      true: `rounded-lg`,
      false: ``,
    },
  },
  defaults: {
    rounded: "true",
  },
});
